import React from 'react'
import { ExcpetionRuleTable } from 'components/table/exceptions/ExceptionTable'

const Exceptions = () => {
    return (
        <>
            <ExcpetionRuleTable />
        </>
    )
}

export { Exceptions }